var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupIconBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\xB9\x9C\xEA\xB5\xAC \xEB\xAA\xA9\xEB\xA1\x9D"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -29,
    y: -747,
    width: 375,
    height: 812,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xED\x95\x98\xEB\x8B\xA8\xEB\xB0\x94",
    clipPath: "url(#clip1_0_1)",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 83,
    transform: "translate(-29 -18)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB0\x90\xEC\x8B\xB8\xEA\xB8\xB0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEC\xB9\x9C\xEA\xB5\xAC gnb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user / group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coolicon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4C8.31812 4 5.33335 6.98477 5.33335 10.6667C5.33335 14.3486 8.31812 17.3333 12 17.3333C15.6819 17.3333 18.6667 14.3486 18.6667 10.6667C18.6667 6.98477 15.6819 4 12 4ZM8.00002 10.6667C8.00002 8.45753 9.79088 6.66667 12 6.66667C14.2092 6.66667 16 8.45753 16 10.6667C16 12.8758 14.2092 14.6667 12 14.6667C9.79088 14.6667 8.00002 12.8758 8.00002 10.6667Z",
    fill: "#166FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5446 10.9577C22.1695 10.7665 21.7544 10.6667 21.3334 10.6667V8.00008C22.1755 8.00008 23.0056 8.19942 23.7559 8.58193C23.8385 8.62406 23.9199 8.66828 24 8.71453C24.6472 9.08818 25.2096 9.59425 25.6498 10.2007C26.1444 10.8823 26.4706 11.6713 26.6017 12.5032C26.7328 13.335 26.665 14.1861 26.4039 14.9867C26.1429 15.7874 25.6959 16.5148 25.0996 17.1095C24.5034 17.7042 23.7748 18.1492 22.9735 18.4082C22.2604 18.6387 21.5078 18.7159 20.7648 18.6363C20.6728 18.6264 20.581 18.6141 20.4894 18.5995C19.6584 18.4663 18.8708 18.1384 18.1909 17.6425L18.1895 17.6415L19.7614 15.4874C20.1015 15.7356 20.4956 15.8997 20.9114 15.9663C21.3271 16.033 21.7527 16.0002 22.1534 15.8707C22.554 15.7412 22.9183 15.5187 23.2164 15.2214C23.5146 14.924 23.738 14.5603 23.8686 14.16C23.9991 13.7597 24.033 13.3342 23.9674 12.9183C23.9019 12.5023 23.7388 12.1079 23.4915 11.7671C23.2442 11.4263 22.9197 11.149 22.5446 10.9577Z",
    fill: "#166FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6642 28C26.6642 27.2999 26.5263 26.6068 26.2584 25.96C25.9905 25.3132 25.5978 24.7256 25.1028 24.2306C24.6078 23.7355 24.0201 23.3429 23.3734 23.075C22.7266 22.8071 22.0334 22.6692 21.3334 22.6692V20C22.2428 20 23.1445 20.1551 24 20.4575C24.1328 20.5045 24.2644 20.555 24.3948 20.609C25.3654 21.011 26.2473 21.6003 26.9902 22.3431C27.7331 23.086 28.3224 23.9679 28.7244 24.9385C28.7784 25.0689 28.8289 25.2006 28.8758 25.3333C29.1783 26.1888 29.3334 27.0906 29.3334 28H26.6642Z",
    fill: "#166FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 28H18.6667C18.6667 24.3181 15.6819 21.3333 12 21.3333C8.31812 21.3333 5.33335 24.3181 5.33335 28H2.66669C2.66669 22.8453 6.84536 18.6667 12 18.6667C17.1547 18.6667 21.3334 22.8453 21.3334 28Z",
    fill: "#166FF6"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -53,
    y: -43,
    width: 423,
    height: 131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -29,
    y: -747,
    width: 375,
    height: 812,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 83,
    fill: "white",
    transform: "translate(-29 -18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIconBlue);
export default __webpack_public_path__ + "static/media/groupIconBlue.18f8aa16933a4b75513c7dbb62b70264.svg";
export { ForwardRef as ReactComponent };